<template>
  <div id="app" class="container" style="max-width: 30%" v-if="uiConfig">
    <div v-if="!isInitializing">
      <div class="text container">
        {{ uiConfig.locales.welcomeText }} <span v-html="uiConfig.locales.title.en" class="admin"></span>
        <br />
        <b>Please enter your pins:</b>
      </div>

      <div class="pin-entry container">
        <section>
          <b-field v-for="(pin, i) in uiConfig.pinCount" :key="i">
            <b-input @keyup.enter.native="nextFocus(i + 1)" :placeholder="'Pin #' + (i + 1)" v-model="pins[i]" v-bind:id="'input' + i" type="text" />
          </b-field>

          <b-button ref="submitButton" expanded size="is-large" @click="submitPin" :disabled="submitDisabled">Download</b-button>
        </section>
      </div>

      <div class="text container">
        Please enter the Pins you received to download your VPN configuration file. For further information please contact the person who gave you this link.
      </div>
    </div>
    <div>
      <p>Your download has been started.</p>
      <p class="download">
        After connecting to the VPN you can enter the<br />
        <a :href="this.uiConfig.home || 'http://192.168.100.1/'">VPN Homepage</a>
      </p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

// https://buefy.org/documentation/layout
import buefy from "buefy";
import "buefy/dist/buefy.css";

import axios from "axios";

import every from "lodash/every";

Vue.use(buefy);

axios.defaults.baseURL = "/";

export default {
  name: "app",

  mounted() {
    if (!!window.location.hash && window.location.hash.match(/#(\w+,)+(\w+)/)) {
      this.inputPins = decodeURIComponent(window.location.hash.slice(1)).toUpperCase().split(",");
    }
    // get settings from api to show a customized pin page
    this.getSettings().then(() => {
      if (!!window.location.hash && window.location.hash.match(/^#[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) {
        this.isInitializing = true;
        window.location.href = this.uiConfig.downloadGuidPath + window.location.hash.slice(1);
      }
    });
  },

  data: function () {
    return {
      uiConfig: null,
      uiConfigDefault: {
        downloadPinPath: "/api/public/dl/",
        downloadGuidPath: "/api/public/download/",
      },
      pins: [], // the pins entered by the user
      inputPins: [],
      isInitializing: false,
      isDownloading: false,
    };
  },

  methods: {
    // https://stackoverflow.com/questions/41270522/populate-table-in-vue-template-component-from-rest-api
    getSettings() {
      return new Promise((resolve, reject) =>
        axios
          .get("api/public/ui/config", {
            dataType: "json",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            mode: "no-cors",
            credentials: "include",
          })
          .then(
            (response) => {
              // debug: console.log(JSON.stringify(response.data));
              this.uiConfig = { ...this.uiConfigDefault, ...response.data };
              this.pins = new Array(this.uiConfig.pinCount);
              if (Array.isArray(this.inputPins)) {
                for (let i = 0; i < this.pins.length && i < this.inputPins.length; i++) {
                  Vue.set(this.pins, i, this.inputPins[i]);
                }
              }

              this.$nextTick(function () {
                // Code that will run only after the
                // entire view has been rendered
                this.nextFocus(0);
              });
              resolve();
            },
            (err) => {
              // this.$buefy.notification.open("Settings Error: " + err);
              console.log("Error getting settings: " + err);
              reject(err);
            }
          )
      );
    },

    submitPin() {
      this.isDownloading = true;
      axios.get(this.uiConfig.downloadPinPath + this.pins.join(",").toUpperCase()).then(
        (response) => {
          this.$buefy.notification.open("Download starting..");

          const type = response.headers["content-type"];
          const blob = new Blob([response.data], {
            type: type,
            encoding: "UTF-8",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download =
            response.headers["content-disposition"].match(/filename=(.+);.+$|filename=(.+)$/)[1] ||
            response.headers["content-disposition"].match(/filename=(.+);.+$|filename=(.+)$/)[2] ||
            "download.ovpn";
          link.click();

          setTimeout(() => {
            let tries = 40;
            if (this.uiConfig.ping) {
              const intervalId = setInterval(() => {
                axios.head(this.uiConfig.ping).then(
                  () => {
                    clearInterval(intervalId);
                    window.location = this.uiConfig.home;
                  },
                  () => {
                    tries--;
                    if (tries <= 0) {
                      clearInterval(intervalId);
                      this.isDownloading = true;
                    }
                  }
                );
              }, 5000);
            }
          }, 2000);
        },
        (err) => {
          this.isDownloading = false;
          this.$buefy.notification.open("Error, please check your PIN");
          console.log("Error getting download file: " + err);
        }
      );
    },
    // focus on the next input field
    nextFocus(i) {
      if (i === this.pins.length) {
        this.$refs.submitButton.$el.click();
      } else {
        document.getElementById("input" + i).focus();
      }
    },
  },

  computed: {
    submitDisabled() {
      // if user entered sth. in all pin entry fields
      return this.isDownloading || !every(this.pins, (element) => (element || "").trim());
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.pin-entry input {
  text-transform: uppercase;
  text-align: center;
}

.download {
  font-size: 150%;
}

.admin {
  color: #000;
  text-decoration: none;
  font-size: 1rem;
}
</style>
